import { SitecoreContextValue } from '@sitecore-jss/sitecore-jss-nextjs';
import { EventDetailResponse, EventOccurrence } from 'components/Events/EventDetail/Types/EventDetailResponse.Type';
import { dataFetcher, dataFetcherGet } from 'lib/data-fetcher';
import { EventType } from 'lib/enum';
import { Counties } from 'models/plans-search-types';

export const LoadEventOccurrenceEvolveId = async (
  occurrenceId: string,
  targetFieldName: string,
  sitecoreContext: SitecoreContextValue
) => {
  const baseUrl = process.env['PUBLIC_URL'] || '';

  if (!targetFieldName || !occurrenceId) {
    return;
  }

  console.log(`********************** ${targetFieldName} ***********************`);
  const response = await dataFetcher<EventOccurrence[]>(`${baseUrl}/api/events/getEventOccurence`, {
    occurrenceId: occurrenceId,
    language: sitecoreContext.language,
  });

  const data = response.data;
  const eventOccurrence = data && data.length > 0 ? data[0] : null;

  const referenceField = `${eventOccurrence?.evolveEventID?.value || ''}`;

  if (referenceField) {
    const $eventData = {
      event: '',
      data: {
        fieldName: targetFieldName,
        targetFieldName: '',
        eventType: EventType.SET_VALUE,
        fieldValue: referenceField,
      },
    };

    console.log(`Load Event Title: ${occurrenceId} -> ${targetFieldName} -> ${referenceField}`, $eventData);
    window.postMessage($eventData, '*');
  }
};

export const LoadEventTitleById = async (
  eventId: string,
  targetFieldName: string,
  sitecoreContext: SitecoreContextValue
) => {
  const baseUrl = process.env['PUBLIC_URL'] || '';

  if (!targetFieldName || !eventId) {
    return;
  }

  console.log(`********************** ${targetFieldName} ***********************`);
  const response = await dataFetcher<EventDetailResponse[]>(`${baseUrl}/api/events/getEventDetail`, {
    eventItemId: eventId,
    language: sitecoreContext.language,
  });

  const data = response.data;
  const eventDetail = data && data.length > 0 ? data[0] : null;

  const eventTitle = `${eventDetail?.name?.value || ''}`;

  if (eventTitle) {
    const $eventData = {
      event: '',
      data: {
        fieldName: targetFieldName,
        targetFieldName: '',
        eventType: EventType.SET_VALUE,
        fieldValue: eventTitle,
      },
    };

    console.log(`Load Event Title: ${eventId} -> ${targetFieldName} -> ${eventTitle}`, $eventData);
    window.postMessage($eventData, '*');
  }
};

export const LoadCountiesByZipCode = async (zipcode: string, fieldName: string, targetFieldName: string) => {
  if (!targetFieldName) {
    return;
  }
  const zipCodePattern = /^\d{5}$/;
  let counties: string[] = [];

  if (zipCodePattern.test(zipcode)) {
    console.log(`Load counties for zipcode: ${zipcode} -> ${targetFieldName}`);
    const baseUrl = process.env['PUBLIC_URL'] || '';
    const apiUrl = `${baseUrl}/sc-api/custom/zipcodecounty/getcounties/${zipcode}`;

    try {
      const { data } = await dataFetcherGet<Counties>(apiUrl);
      counties = data.counties?.map((county) => county.CountyName) || [];
    } catch {
      counties = [];
    }

    if (counties.length === 0) {
      const $eventData = {
        event: '',
        data: {
          fieldName: fieldName,
          targetFieldName: '',
          eventType: EventType.ERROR,
          fieldValue: 'No-Plans-For-Zipcode',
        },
      };

      window.postMessage($eventData, '*');
    }

    const $eventData = {
      event: '',
      data: {
        fieldName: targetFieldName,
        targetFieldName: '',
        eventType: [EventType.SET_VALUE, EventType.LOAD_VALUES].join(','),
        fieldValue: counties,
      },
    };

    window.postMessage($eventData, '*');
  } else {
    const nonNumericPattern = /\D/;
    if (nonNumericPattern.test(zipcode)) {
      const $eventData = {
        event: '',
        data: {
          fieldName: fieldName,
          targetFieldName: '',
          eventType: EventType.ERROR,
          fieldValue: 'Invalid-Zipcode',
        },
      };

      window.postMessage($eventData, '*');
    }
  }
};
